export default {
  ALLOWED: 'autoplay-allowed',
  BLOCKED: 'autoplay-blocked',
  MUTED_ALLOWED: 'autoplay-muted-allowed',
};
